import React, { useCallback, useEffect, useRef, useState } from 'react';

import BookDemoButton from 'pages/Landings/components/BookDemoButton';
import StartTrialButton from 'pages/Landings/components/StartTrialButton';
import Title from 'pages/Landings/components/Title';

import useStyles from './styles';

interface Props {
    className?: string;
}

const TITLES = [
    'Every vulnerability. One database.',
    'All-in-one vulnerability intelligence',
    'Prioritize like an attacker, not a spreadsheet'
];

const TIMEOUT = 5_000;

enum Stage {
    ENTERING,
    ENTERED,
    EXITING,
    EXITED
}

const TitleSection: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const timerRef = useRef<number>();

    const [state, setState] = useState({
        index: 0,
        stage: Stage.ENTERED
    });

    useEffect(() => {
        if (state.stage === Stage.ENTERED) {
            timerRef.current = window.setTimeout(
                () => setState((state) => ({ ...state, stage: Stage.EXITING })),
                TIMEOUT
            );
        } else if (state.stage === Stage.EXITED) {
            setState((state) => ({ ...state, index: (state.index + 1) % TITLES.length, stage: Stage.ENTERING }));
        }
    }, [state]);

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    const handleTransitionEnd = useCallback(() => {
        setState((state) => {
            switch (state.stage) {
                case Stage.ENTERING:
                    return { ...state, stage: Stage.ENTERED };
                case Stage.EXITING:
                    return { ...state, stage: Stage.EXITED };
                default:
                    return state;
            }
        });
    }, []);

    return (
        <section className={cx(classes.root, className)}>
            <Title
                variant="h1"
                className={classes.title}
                style={{
                    ...(state.stage === Stage.ENTERING || state.stage === Stage.ENTERED ? { opacity: 1 } : {}),
                    ...(state.stage === Stage.EXITING || state.stage === Stage.EXITED ? { opacity: 0 } : {})
                }}
                onTransitionEnd={handleTransitionEnd}
            >
                {TITLES[state.index]}
            </Title>
            <div className={classes.buttons}>
                <BookDemoButton className={classes.button} />
                <StartTrialButton className={classes.button} />
            </div>
        </section>
    );
};

export default TitleSection;
